import './style.css';

import React from 'react';
import { connect } from 'react-redux';
import {
	Collapse,
	Nav,
	Navbar
} from 'reactstrap';
import UIDucks from 'stores/ducks/UI.duck';

interface IAppBarProps {
	isLoggedIn?: boolean;
	dispatch?: any;
	isOpened?: boolean;
	isOpened2?: boolean;
	isVisible?: boolean;

	state?: any;
	user?: {
		name?: string;
		lastname?: string;
		email?: string;
		avatar?: string;
		stripeId?: string;
		id?: any;
		roles?: any;
	};
}
export class AppBar extends React.Component<IAppBarProps, { [label: string]: any }> {
	constructor(props) {
		super(props);
		this.state = {
			searchTerm: '',
			imgUrl: '',
			loading: false
		}
	}

	public render() {

		const logo = require('./Dark-logo.png');
		return (
			<div key={window.location.pathname} style={{ paddingTop: '20px' }}>
				<Navbar className='sticky-top'
					expand='xs'
					style={{
						maxHeight: screen.width >= 768 ? '50px' : 'auto',
						overflow: 'visible',
						marginTop: screen.width >= 768 ? '5px' : 'none',
						marginBottom: screen.width >= 768 ? '5px' : 'none'
					}}>
					<div className="container">
						{
							this.state.loading ? null :
								<a href='/'
									className="navbar-brand">
									<img src={logo} height="55px" style={{ paddingRight: '10px' }} />
								</a>
						}
						<Collapse isOpen={this.props.isOpened2} navbar={true} style={{ width: 'auto', height: 'auto' }}>
							<Nav className='ml-auto' navbar={true} style={{ paddingTop: '0 auto', paddingBottom: '0 auto', paddingight: '0 auto', float: 'right' }}>
								<div style={{ textAlign: 'center', paddingTop: '0 auto', paddingBottom: '0 auto' }}>
									<span>
										<a href={"https://app.isotopeticketing.com/"}>
											<button className="new-button-white">&nbsp;&nbsp;LOGIN&nbsp;&nbsp;</button>
										</a>
									</span>
								</div>
							</Nav>
							<p />
						</Collapse>
					</div>
				</Navbar>
			</div>
		);
	}

}

const mapStateToProps = state => ({
	isOpened2: UIDucks.getIsNavBarOpen2(state)
});

export default connect(mapStateToProps)(AppBar);



// WEBPACK FOOTER //
// ./src/components/common/controls/navbar/AppBar.tsx